/* Mana Rush v103 — keep subscription prices synchronized with the selected Shopify variant. */
(function(){
  'use strict';

  function productFormForSection(sectionId){
    var forms=document.querySelectorAll('product-form[data-section-id]');
    for(var i=0;i<forms.length;i++)if(forms[i].dataset.sectionId===sectionId)return forms[i];
    return null;
  }

  function applyPurchaseSelection(form,preferred){
    if(!form)return;
    var picker=form.querySelector('.mrg-sub-picker');
    var hidden=form.querySelector('[data-mrg-selling-plan]');
    if(!picker||!hidden)return;
    var radios=Array.from(picker.querySelectorAll('input[type="radio"]'));
    if(!radios.length)return;
    var chosen=radios.find(function(r){return r.value===preferred})||radios.find(function(r){return r.checked})||radios[0];
    radios.forEach(function(r){
      r.checked=r===chosen;
      var opt=r.closest('.mrg-sub-picker__opt');
      if(opt)opt.classList.toggle('mrg-sub-picker__opt--selected',r===chosen);
      if(r.dataset.mrgV103Bound!=='1'){
        r.dataset.mrgV103Bound='1';
        r.addEventListener('change',function(){applyPurchaseSelection(form,r.value)});
      }
    });
    hidden.value=chosen.dataset.planId||'';
    hidden.dispatchEvent(new Event('change',{bubbles:true}));
  }

  function bindPurchasePickers(root){
    var scope=root&&root.querySelectorAll?root:document;
    var forms=[];
    if(scope.matches&&scope.matches('product-form[data-section-id]'))forms.push(scope);
    if(scope.querySelectorAll)forms=forms.concat(Array.from(scope.querySelectorAll('product-form[data-section-id]')));
    forms.forEach(function(form){
      var checked=form.querySelector('.mrg-sub-picker input[type="radio"]:checked');
      applyPurchaseSelection(form,checked?checked.value:'onetime');
    });
  }

  function refreshPurchasePicker(payload){
    var data=payload&&payload.data;
    if(!data||!data.html||!data.sectionId)return;
    var form=productFormForSection(data.sectionId);
    if(!form)return;
    var current=form.querySelector('.mrg-sub-picker');
    var incoming=data.html.querySelector('.mrg-sub-picker');
    if(!current||!incoming)return;
    var checked=current.querySelector('input[type="radio"]:checked');
    var preferred=checked?checked.value:'onetime';
    current.replaceWith(incoming.cloneNode(true));
    applyPurchaseSelection(form,preferred);
  }

  function start(){
    bindPurchasePickers(document);
    document.documentElement.classList.add('mrg-v103-sub-ready');
    if(typeof window.subscribe==='function'&&window.PUB_SUB_EVENTS&&PUB_SUB_EVENTS.variantChange){
      window.subscribe(PUB_SUB_EVENTS.variantChange,function(event){refreshPurchasePicker(event)});
    }
    document.addEventListener('shopify:section:load',function(e){bindPurchasePickers(e.target)});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
